import request from '../utils/http'

export function getmessage() {
    return request({
        url: '/api/getMessage',
        method: 'post'
    })
}



// WEBPACK FOOTER //
// ./src/api/message.js